import { FaqSchema } from "@/components/FaqSchema";
import { ContentPageNav } from "@/components/ContentPageNav";
import { Footer } from "@/components/Footer";

export interface SeoContentData {
  breadcrumb: string;
  h1: string;
  intro: string;
  sections: { h2: string; body: string }[];
  ctaTitle: string;
  ctaText: string;
  faqs: { q: string; a: string }[];
}

export function buildSeoHtml(d: SeoContentData): string {
  const sections = d.sections
    .map(
      (s) => `<section><h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">${s.h2}</h2><div class="text-muted-foreground leading-relaxed space-y-4">${s.body}</div></section>`,
    )
    .join("");
  const faqs = d.faqs
    .map(
      (f) => `<details class="group rounded-lg border border-border bg-card p-4 md:p-5"><summary class="flex items-center justify-between gap-3 cursor-pointer list-none"><h3 class="text-base md:text-lg font-semibold text-foreground">${f.q}</h3></summary><div class="mt-3 text-muted-foreground leading-relaxed">${f.a}</div></details>`,
    )
    .join("");
  return `<nav aria-label="Kruimelpad" class="px-3 pt-4 pb-2"><div class="container mx-auto max-w-6xl"><ol class="flex flex-wrap items-center gap-2 text-sm"><li class="flex items-center gap-2"><a href="/" class="text-muted-foreground hover:text-foreground transition-colors">Home</a></li><li class="text-foreground font-medium" aria-current="page">${d.breadcrumb}</li></ol></div></nav>
<header class="py-10 md:py-20 px-3"><div class="container mx-auto max-w-3xl"><h1 class="text-3xl md:text-5xl font-bold text-foreground mb-6">${d.h1}</h1><p class="text-lg md:text-xl text-muted-foreground leading-relaxed">${d.intro}</p></div></header>
<article class="px-3 pb-6"><div class="container mx-auto max-w-3xl space-y-8">${sections}</div></article>
<section class="py-10 md:py-16 px-3"><div class="container mx-auto max-w-3xl"><div class="p-5 md:p-10 text-center rounded-lg border border-accent/30 bg-accent/10"><h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">${d.ctaTitle}</h2><p class="text-lg text-muted-foreground mb-6">${d.ctaText}</p><a href="/club-register" class="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent text-accent-foreground font-medium hover:bg-accent/90 transition-colors">Registreer je club</a></div></div></section>
<section class="py-10 md:py-16 px-3"><div class="container mx-auto max-w-4xl"><h2 class="text-2xl md:text-3xl font-bold text-foreground mb-6 md:mb-8 text-center">Veelgestelde vragen</h2><div class="space-y-3">${faqs}</div></div></section>`;
}

export const SeoContentPage = ({ data }: { data: SeoContentData }) => {
  const html = buildSeoHtml(data);
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <ContentPageNav showPricing />
      <div className="flex-1 marketing-content" dangerouslySetInnerHTML={{ __html: html }} />
      <FaqSchema html={html} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: "https://dehusselapp.nl/" },
              { "@type": "ListItem", position: 2, name: data.breadcrumb },
            ],
          }),
        }}
      />
      <Footer />
    </div>
  );
};
